// extracted by mini-css-extract-plugin
export var active = "_cg-2";
export var recordingDot = "_cg-1";
export var recordingIndicator = "_cg-0";